import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/helpers/init-observer';
import {Slideshow} from '@archetype-themes/scripts/modules/slideshow';

class FeaturedProducts extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('#slider');
    this.activeCollectionIndex = this.getAttribute('data-active-collection-index');
    this.isMobileArrowsEnabled = this.getAttribute('data-show-mobile-arrows');
    this.collectionButtons = this.querySelectorAll('.collection-button');
    this.slides = this.slider.querySelectorAll('#product');
    this.isTablet = matchMedia('screen and (min-width: 576px) and (max-width: 768px)').matches;
    this.isDesktop = matchMedia('screen and (min-width: 769px)').matches;

    this.collectionButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        const buttonEL = button;
        this.toggleCollections(index);

        buttonEL.disabled = true;
      });
    });

    this.options = {
      cellAlign: 'left',
      wrapAround: false,
      prevNextButtons: this.isMobileArrowsEnabled === 'true' && this.activeSlidesCount > 1,
      draggable: this.activeSlidesCount > 1,
      contain: true,
      lazyLoad: true,
      groupCells: true,
      arrowShape:
        'M45.107632 5.82952 L53.53207 14.795201 L24.285714 46.292352 L97.808833 46.292352 L97.808833 59.383744 L24.285714 59.383744 L53.53207 90.877568 L45.107615 99.952178 L1.377755 53.778731 L45.107632 5.82952 Z',
    };

    if (this.isTablet) {
      this.options.prevNextButtons = this.activeSlidesCount > 2;
      this.options.draggable = this.activeSlidesCount > 2;
    }

    if (this.isDesktop) {
      this.options.draggable = this.activeSlidesCount > 3;
      this.options.prevNextButtons = this.activeSlidesCount > 3;
    }

    theme.initWhenVisible({
      element: this.slider,
      callback: this.setupSlider.bind(this),
    });
  }

  static get observedAttributes() {
    return ['data-active-collection-index'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-active-collection-index') {
      this.activeCollectionIndex = newValue;

      this.setupSlider();
    }
  }

  get activeSlidesCount() {
    return this.flickity ? this.flickity.slideshow.cells.length : this.slides.length;
  }

  toggleCollections(buttonIndex) {
    this.setAttribute('data-active-collection-index', buttonIndex + 1);

    this.collectionButtons.forEach((button, index) => {
      const buttonEL = button;

      buttonEL.classList.toggle('active', String(index + 1) === this.activeCollectionIndex);
      buttonEL.disabled = String(index + 1) === this.activeCollectionIndex;
    });
  }

  toggleButtonsVisibility() {
    this.prevNextButtons = this.slider.querySelectorAll('.flickity-prev-next-button');

    const toggleVisibility = (button) => {
      if (this.isTablet) {
        button.classList.toggle('hidden', this.activeSlidesCount <= 2);
        return;
      }

      if (this.isDesktop) {
        button.classList.toggle('hidden', this.activeSlidesCount <= 3);
        return;
      }

      button.classList.toggle(
        'hidden',
        this.isMobileArrowsEnabled === 'false' || this.activeSlidesCount <= 1
      );
    };

    this.prevNextButtons.forEach((button) => {
      toggleVisibility(button);
    });
  }

  setupSlider() {
    this.activeSlides = [...this.slides].filter((slide) => {
      const collectionIndex = slide.getAttribute('data-collection-index');
      return collectionIndex === this.activeCollectionIndex;
    });

    this.inactiveSlides = [...this.slides].filter((slide) => {
      const collectionIndex = slide.getAttribute('data-collection-index');
      return collectionIndex !== this.activeCollectionIndex;
    });

    if (this.flickity) {
      this.flickity.slideshow.remove(this.inactiveSlides);
      this.flickity.slideshow.insert(this.activeSlides);
      this.flickity.slideshow.reloadCells();
      this.flickity.slideshow.select(0, false, true);
      this.toggleButtonsVisibility();
      return;
    }

    this.flickity = new Slideshow(this.slider, this.options);
  }
}

customElements.define('featured-products', FeaturedProducts);
